<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-outTabs">
        <ejs-tab ref="tabObj" id="tab_orientation" heightAdjustMode="Auto" :selecting="disableSelecting">
          <e-tabitems>
            <e-tabitem :header="headerText0" content="#idv1"></e-tabitem>
            <e-tabitem :header="headerText1" content="#idv2"></e-tabitem>
          </e-tabitems>
        </ejs-tab>
        <div id="idv1" style="display: none">
          <ConfigBackup></ConfigBackup>
        </div>
        <div id="idv2" style="display: none">
          <ConfigRecover></ConfigRecover>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import ConfigBackup from './ConfigBackup.vue';
import ConfigRecover from './ConfigRecover.vue';
import BasicLayout from "../../layouts/BasicLayout";
import CustomDialog from "../../components/common/CustomDialog";

export default {
  name: "configBackupAndRecover",
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('System.config')}`+'/' + `${this.$t('System.configBackupAndRecover')}`},
      headerText0: { text: `${this.$t('MML.backup')}` },
      headerText1: { text: `${this.$t('MML.recover')}` },
    }
  },
  components: {
    ConfigBackup,
    ConfigRecover,
    BasicLayout,
    CustomDialog
  },
  methods: {
    disableSelecting(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },

  }
}
</script>

<style scoped>

</style>
